import { assert_nested_coords, deep_copy_coords, mid_pos } from "../MapViewController";
import { SkPolygonDisplayItem, SkStairsDisplayItem } from "../stek/sk-display";
import { addCoordinatesOperation, addFloorGetSet, addFloorObjProps, B_AttrFlags, BBase, BEV_MODIFIED, kFloorZBias, kOnFloorItemZBias, register_b_class } from "./BBase";
import { get_next_floor } from "./BNode";

class BPolyline extends addCoordinatesOperation(addFloorGetSet(BBase)) {
	constructor(flags, forceSetId) {
		super(flags, forceSetId);
		addFloorObjProps(this);

		this.mapFeautre = null;
		this.editorFeatures = null;

		this.geometryType = "Polygon";
		this.requireVertexHandle = true;
	}

	splitEdge(loopIndex, afterThisIndex) {
		const loop = this.coordinates[loopIndex];

		const n = loop.length;
		const c1 = loop[afterThisIndex];
		const c2 = loop[ (afterThisIndex+1) % n ];

		loop.splice(afterThisIndex + 1, 0, mid_pos(c1, c2));

		this.updateXyCoordinates();
		if (this.onCoodinateChange) {
			this.fireEvent(this, BEV_MODIFIED);
		}

		return afterThisIndex + 1;
	}

	generateDisplayList(outList) {
		if (!this.floor) {
			console.log("%c[WARNING] Floor is not set.", "color:#F09");
			return;	
		}

		if (this.flags & B_AttrFlags.Stairs) {
			this.generateStairDisplayList(outList);
		} else {
			this.generateRegularDisplayList(outList);
		}
	}

	generateRegularDisplayList(outList) {
		const isInner = (0 === (this.flags & B_AttrFlags.BuildingOuter));
		const d = new SkPolygonDisplayItem();

		const loopList = this.xyCoordinates;

		let totalLen = 0;
		for (const lp of loopList) {
			const lplen = lp.length;
			d.loopLengthList.push( lplen );
			totalLen += lplen;
		}

		d.vpool.resize(totalLen);
		write_all_coords(d.vpool, loopList);

		this.writeTransformInfo(d);
		if (!isInner) {
			d.withShadow = (0 === this.floor.stackOrder) ? 2 : 1;
		}

		// Inner polygons have a slight priority.
		if (isInner) {
			d.sortBias += kOnFloorItemZBias;
			d.setInnerPolygonPreset();
		} else {
			d.setOuterPolygonPreset();
		}

		outList.push(d);
	}

	generateStairDisplayList(outList) {
		const nextFloor = get_next_floor(this);
		if (!nextFloor) { return; }

		const d = new SkStairsDisplayItem();
		const loopList = this.xyCoordinates;

		this.writeTransformInfo(d);
		d.sortBias += kOnFloorItemZBias;

		const alt_diff = nextFloor.floorAltitude - this.floor.floorAltitude;
		if (write_stair_vertices(d.vpool, loopList, alt_diff)) {
			outList.push(d);
		}
	}

	writeTransformInfo(d_item) {
		d_item.useLocalTransform();
		this.floor.connectTransformTreeItemIf(d_item);

		// The order of the floor is highly prioritized.
		d_item.sortBias = this.floor.stackOrder * kFloorZBias;
	}

	serialize() {
		const o = super.serialize();
		o.coordinates = deep_copy_coords(this.coordinates);

		return o;
	}

	deserialize(o) {
		assert_nested_coords(o.coordinates);
		this.copyAllCoordinates(o.coordinates);

		this.saveCoordinates();
		this.updateXyCoordinates();
	}
}

function write_stair_vertices(vpool, loopList, stairHeight) {
	const firstLoop = loopList[0];
	if (Array.isArray(firstLoop) && firstLoop.length >= 2) {
		const n = firstLoop.length;
		vpool.resize(n+1);
		for (let i = 0;i < n;++i) {
			const v = vpool.at(i);
			const xy = firstLoop[i];
			v.pos.set3d(xy[0], xy[1], 0);

			if (i === (n-1)) {
				vpool.at(n).pos.set3d(xy[0], xy[1], stairHeight);
			}
		}
		return true;
	}

	return false;
}

function write_all_coords(vpool, loopList) {
	let writePos = 0;
	for (const lp of loopList) {
		for (const srcCoord of lp) {
			const v = vpool.at(writePos++);
			v.pos.set3d(srcCoord[0], srcCoord[1], 0);
		}
	}
}

register_b_class(BPolyline);
export default BPolyline;